/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import ReCAPTCHA from 'react-google-recaptcha';
import _ from 'lodash';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Button, CheckboxGroup, Notification, Typography } from '@telus-uds/components-web';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import PasswordMessage from './passwordMessage';
import { Wrapper, Box } from './css';
import RegistrationModal from './modal';
import { getLocalizedStrings } from '../misc';

import {
  RECAPTCHA_SITE_KEY,
  channels,
  referalChannels,
  CONSTANT,
  channelOutletMapping,
  storeCodeOutletMapping,
  outletIdStoreCodeMapping
} from '../utils/constant';
import { useTranslationsContext } from '../context/TranslationsContext';
import RestChannelsForm from './forms/restChannelsForm';
import BcxCareForm from './forms/bcxCareForm';
import SBSTISalesForm from './forms/sbsTiSalesForm';
import DealerForm from './forms/dealerForm';
import CorpStoreForm from './forms/corpStoreForm';
import TelusSalesManagerForm from './forms/telusSalesManagerForm';
import request from '../utils/request';
import { sortedObjects, useFormikScrollToError } from '../utils/utils';

const salesManagerForm = ({
  labels,
  schema,
  onSubmit,
  initialValues,
  loading,
  onChange,
  showModal,
  confirmationDialog,
  errorMessages,
  channelsList,
  provincesList,
  isRedirectedFromPassport
}) => {
  const {
    headerLinks: { province, channelss, supportchaneels, selectoption, Select_PROVINCE, Select_Channels },
    USERS: {
      USER_AUTHENTICATION: {
        REGISTRATION_SCHEMA_MESSAGES: {
          CHANNELORGCODE_REQUIRED,
          STORECODE_REQUIRED,
          DEALERSHIP_REQUIRED,
          CPMS_REQUIRED,
          XID_REQUIRED,
          OUTLET_REQUIRED,
          SALES_MANAGER_REQUIRED,
          SALES_MANAGER_EMAIL_REQUIRED,
          REQUIRES_ORDER_ACCESS_REQUIRED
        }
      }
    }
  } = getLocalizedStrings();
  const {
    KEYS: { CHANNELS, ROLES }
  } = CONSTANT;

  const roles = [
    {
      text: 'Sales Rep',
      value: 'SALES_REP'
    },
    {
      text: 'Sales Manager',
      value: 'SALES_MANAGER'
    },
    {
      text: 'Sales Support',
      value: 'SALES_SUPPORT'
    }
  ];

  const [validDomains, setValidDomain] = useState([]);
  var [channelArray, setChannelArray] = useState([]);
  var [provinceArray, setProvinceArray] = useState([]);

  const techChannels = () => {
    return channelsList.filter(item => {
      return ['ADT', 'CSD', 'NBD'].includes(item.value);
    });
  };

  const salesRepChannels = () => {
    return channelsList.filter(item => {
      return item.value;
    });
  };

  const salesManagerChannels = () => {
    return channelsList.filter(item => {
      return item.value;
    });
  };

  const salesSupportChannels = () => {
    return channelsList.filter(item => {
      return item.value;
    });
  };

  const getChannels = role => {
    let tempChannels = salesRepChannels();
    if (role === 'ADT_RETENTION') {
      tempChannels = [...channels, ...referalChannels];
    }
    if (role === 'TECH') {
      tempChannels = [...techChannels()];
    }
    if (role === 'SALES_REP') {
      tempChannels = [...salesRepChannels()];
    }
    if (role === 'SALES_MANAGER') {
      tempChannels = [...salesManagerChannels()];
    }
    if (role === 'SALES_SUPPORT') {
      tempChannels = [...salesSupportChannels()];
    }
    tempChannels.sort((a, b) =>
      // eslint-disable-next-line no-nested-ternary
      a.text > b.text ? 1 : b.text > a.text ? -1 : 0
    );
    return tempChannels || [];
  };

  const getDomains = () => {
    request.get(`/domains`).then(response => {
      if (response && response.status === 200) {
        if (response.data && response.data.rows && response.data.rows.length) {
          setValidDomain(response.data.rows);
        }
      }
    });
  };

  const getChannel = outletValue => {
    let result = '';
    Object.keys(channelOutletMapping).forEach(channel => {
      if (_.get(channelOutletMapping, channel, []).includes(outletValue))
        result = channelsList.filter(ch => ch.label === channel);
    });
    return result;
  };

  const getMappedStoreCode = outletId => {

    return outletIdStoreCodeMapping[outletId] || null;
};

  // const getNameOfSelectedChannel = (tempChannelsList, value) => {
  //   value = _.get(value, '0', '')
  //   /* eslint-disable react/prop-types */
  //   let channelOptions = '';
  //   try {
  //     channelOptions =
  //       tempChannelsList.filter(item => item.id === value)[0].label || '';
  //   } catch (err) {
  //     channelOptions = '';
  //   }
  //   return channelOptions;
  //   /* eslint-disable react/prop-types */
  // };

  const getChannelData = channel => {
    let channelArr = channelsList.filter(item => item.value === channel);
    return _.get(channelArr, '0', '');
  };

  useEffect(() => {
    getDomains();
  }, []);

  // Helper function to ensure unique items for CheckboxGroup
  // CheckboxGroup requires both id AND label to be unique
  const getUniqueItems = (items, getId, getLabel) => {
    if (!items || !Array.isArray(items) || items.length === 0) return [];
    
    const seenIds = new Set();
    const seenLabels = new Set();
    
    return items
      .filter(item => {
        if (!item) return false;
        
        const id = getId(item);
        const label = getLabel(item);
        
        // Both id and label must be present and unique
        if (!id || !label) return false;
        if (seenIds.has(id)) return false;
        if (seenLabels.has(label)) return false;
        
        seenIds.add(id);
        seenLabels.add(label);
        return true;
      })
      .map(item => ({
        label: getLabel(item),
        id: getId(item)
      }));
  };

  // Helper function to check if channels array includes a specific channel
  // Handles both array of objects (from CheckboxGroup/Typeahead) and checks by channel value
  const channelsIncludes = (channels, channelName) => {
    if (!channels) return false;
    if (!Array.isArray(channels)) return false;
    if (channels.length === 0) return false;
    
    // Check if any channel in the array matches the channel name
    return channels.some(ch => {
      if (!ch) return false;
      
      // If ch is a string, compare directly
      if (typeof ch === 'string') {
        return ch === channelName;
      }
      
      // If ch is an object, check the value property
      if (typeof ch === 'object') {
        // Check if ch.value matches the channel name
        if (ch.value === channelName) return true;
        
        // Check if ch matches the channel object from getChannelData (for Typeahead format)
        const channelData = getChannelData(channelName);
        if (channelData && (ch.value === channelData.value || ch === channelData)) return true;
      }
      
      return false;
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={(values, actions) => {
        onSubmit(values, actions);
      }}
      validate={values => {
        const errors = {};
        if (values.email.includes('@')) {
          const domain = values.email.substring(
            values.email.lastIndexOf('@') + 1
          );
          if (
            !validDomains.some(el => {
              return el.name === domain;
            })
          ) {
            errors.email = errorMessages.INVALID_EMAIL_DOMAIN;
          }
        }
        // DEALERSHIP REQUIRED
        if (
          values.role !== ROLES.SALES_SUPPORT &&
          !values.dealership &&
          values.channels &&
          channelsIncludes(values.channels, CHANNELS.DEALER)
        ) {
          errors.dealership = DEALERSHIP_REQUIRED;
        }
        // CHANNEL_ORG CODE REQUIRED
        if (
          values.role === ROLES.SALES_MANAGER &&
          !values.channelOrgCode
        ) {
          errors.channelOrgCode = CHANNELORGCODE_REQUIRED;
        }
        if (
          values.role !== ROLES.SALES_SUPPORT &&
          !values.channelOrgCode &&
          values.channels &&
          channelsIncludes(values.channels, CHANNELS.DEALER)
        ) {
          errors.channelOrgCode = CHANNELORGCODE_REQUIRED;
        }
        // STORE CODE REQUIRED
        if (
          !values.storeCode &&
          values.channels &&
          channelsIncludes(values.channels, CHANNELS.CORP_STORE)
        ) {
          errors.storeCode = STORECODE_REQUIRED;
        }
        //CPMS REQUIRED
        if (
          ![ROLES.SALES_SUPPORT, ROLES.SALES_MANAGER].includes(values.role) &&
          !values.cpmsId &&
          !channelsIncludes(values.channels, CHANNELS.BCX_CARE) &&
          !channelsIncludes(values.channels, CHANNELS.ADT) &&
          !channelsIncludes(values.channels, CHANNELS.HEALTH) &&
          !channelsIncludes(values.channels, CHANNELS.CSD) &&
          !channelsIncludes(values.channels, CHANNELS.NBD)
        ) {
          errors.cpmsId = CPMS_REQUIRED;
        }
        // REQUIRES ORDER ACCESS REQUIRED (Sales Manager + Dealer)
        if (
          values.role === ROLES.SALES_MANAGER &&
          values.channels &&
          values.channels.includes(getChannelData(CHANNELS.DEALER)) &&
          !values.requiresOrderAccess
        ) {
          errors.requiresOrderAccess = REQUIRES_ORDER_ACCESS_REQUIRED;
        }
        // CPMS REQUIRED when SM + Dealer + requiresOrderAccess = yes
        if (
          values.role === ROLES.SALES_MANAGER &&
          values.channels &&
          values.channels.includes(getChannelData(CHANNELS.DEALER)) &&
          values.requiresOrderAccess === 'yes' &&
          !values.cpmsId
        ) {
          errors.cpmsId = CPMS_REQUIRED;
        }
        // REQUIRES ORDER ACCESS REQUIRED (Sales Manager + Dealer)
        if (
          values.role === ROLES.SALES_MANAGER &&
          values.channels &&
          values.channels.includes(getChannelData(CHANNELS.DEALER)) &&
          !values.requiresOrderAccess
        ) {
          errors.requiresOrderAccess = REQUIRES_ORDER_ACCESS_REQUIRED;
        }
        // CPMS REQUIRED when SM + Dealer + requiresOrderAccess = yes
        if (
          values.role === ROLES.SALES_MANAGER &&
          values.channels &&
          values.channels.includes(getChannelData(CHANNELS.DEALER)) &&
          values.requiresOrderAccess === 'yes' &&
          !values.cpmsId
        ) {
          errors.cpmsId = CPMS_REQUIRED;
        }
        //XID REQUIRED
        if (
          !values.xid &&
          ([ROLES.SALES_SUPPORT].includes(values.role) ||
            channelsIncludes(values.channels, CHANNELS.BCX_CARE) ||
            channelsIncludes(values.channels, CHANNELS.HEALTH) ||
            channelsIncludes(values.channels, CHANNELS.CSD) ||
            channelsIncludes(values.channels, CHANNELS.NBD) ||
            channelsIncludes(values.channels, CHANNELS.ADT))
        ) {
          errors.xid = XID_REQUIRED;
        }
        //OUTLET REQUIRED
        if (
          !values.outlet &&
          ![ROLES.SALES_SUPPORT].includes(values.role) &&
          ((values.channels &&
            !channelsIncludes(values.channels, CHANNELS.BCX_CARE) &&
            !channelsIncludes(values.channels, CHANNELS.ADT) &&
            !channelsIncludes(values.channels, CHANNELS.HEALTH) &&
            !channelsIncludes(values.channels, CHANNELS.CSD) &&
            !channelsIncludes(values.channels, CHANNELS.NBD)) ||
            (!values.channels && values.role))
        ) {
          errors.outlet = OUTLET_REQUIRED;
        }
        //SALES MANAGER REQUIRED
        if (
          !values.salesManager &&
          [ROLES.SALES_REP, ROLES.SALES_MANAGER, ROLES.SALES_SUPPORT].includes(
            values.role
          )
        ) {
          errors.salesManager = SALES_MANAGER_REQUIRED;
        }
        // SALES MANAGER EMAIL REQUIRED
        if (
          !values.salesManagerEmail &&
          [ROLES.SALES_REP, ROLES.SALES_MANAGER, ROLES.SALES_SUPPORT].includes(
            values.role
          )
        ) {
          errors.salesManagerEmail = SALES_MANAGER_EMAIL_REQUIRED;
        }

        return errors;
      }}
    >
      {({
        handleSubmit,
        submitForm,
        errors,
        touched,
        values,
        setFieldValue,
        isValidating,
        isSubmitting
      }) => {
        useFormikScrollToError(isSubmitting, isValidating, errors);
        return (
          <Form onSubmit={handleSubmit}>
            <div
              className="main-content-form-headers"
              style={{ marginTop: 20 }}
            >
              <Typography>{labels.USER_ROLE}</Typography>
            </div>
            <div
              style={{ position: 'relative', width: '100%' }}
              className={`frg-select-container color-light input-container ${errors.role && touched.role ? 'error' : ''
                }`}
            >
              <Field as="select"
                name="role" className="select-style">
                <option style={{ color: '#c3bfbf' }} disabled selected={!(touched && touched.role)} value="">
                  {selectoption}
                </option>
                {roles &&
                  roles.length > 0 &&
                  sortedObjects(roles, 'text').map(role => (
                    <option value={role.value}>{role.text}</option>
                  ))}
              </Field>
              <>
                <div className="error_messages">
                  <Typography variant={{ colour: 'error' }}>{errors.role}</Typography>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            {values.role === 'SALES_SUPPORT' && (
              <Wrapper>
                <Notification variant={{ validation: 'warning' }} copy="en">
                  <Typography>
                    <b>{labels.NOTE}</b>: {labels.Role_Note}
                  </Typography>
                </Notification>
              </Wrapper>
            )}
            </div>
            <div className="main-content-form-headers">
              <Typography>{labels.FIRST_NAME}</Typography>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.firstName && touched.firstName ? 'error' : ''
                }`}
            >
              {showModal && (
                <RegistrationModal show labels={confirmationDialog} />
              )}
              <Field
                name="firstName"
                type="text"
                className="select-style"
                placeholder={labels.FIRST_NAME}
                disabled={isRedirectedFromPassport}
              />
              <>
                <div className="error_messages">
                  <Typography variant={{ colour: 'error' }}>{errors.firstName}</Typography>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers">
              <Typography>{labels.LAST_NAME}</Typography>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.lastName && touched.lastName ? 'error' : ''
                }`}
            >
              <Field
                name="lastName"
                type="text"
                className="select-style"
                placeholder={labels.LAST_NAME}
                disabled={isRedirectedFromPassport}
              />
              <>
                <div className="error_messages">
                  <Typography variant={{ colour: 'error' }}>{errors.lastName}</Typography>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers">
              <Typography>{labels.EMAIL}</Typography>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.email && touched.email ? 'error' : ''
                }`}
            >
              <Field
                name="email"
                type="email"
                className="select-style"
                style={{ width: '100%' }}
                // onChange={(event) => {
                //   const domain = event.target.value.substring(event.target.value.lastIndexOf("@") +1);
                //   console.log('Domains: ', domain);
                // }}
                placeholder={labels.PLACEHOLDER_EMAIL}
                disabled={isRedirectedFromPassport}
              />
              <>
                <div className="error_messages">
                  <Typography variant={{ colour: 'error' }}>{errors.email}</Typography>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>

            <Wrapper>
              <Notification copy="en">
                <Typography>
                  <b>{labels.NOTE}</b>: {labels.EMAIL_MESSAGE}
                </Typography>
              </Notification>
            </Wrapper>
            <div className="main-content-form-headers">
              <Typography>{labels.PASSWORD}</Typography>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.password && touched.password ? 'error' : ''
                }`}
            >
              <Field
                type="password"
                name="password"
                style={{ width: '100%' }}
                placeholder={labels.PLACEHOLDER_PASSWORD}
                className="select-style"
              />
              <>
                <div className="error_messages">
                  <Typography variant={{ colour: 'error' }}>{errors.password}</Typography>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>

            <PasswordMessage />
            <div className="main-content-form-headers">
              <Typography>
                {labels.CONTACT_NUMBER}
              </Typography>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.contactNumber && touched.contactNumber ? 'error' : ''
                }`}
            >
              <Field
                placeholder={labels.CONTACT_NUMBER}
                name="contactNumber"
                className="select-style"
                type="text"
              />
              <>
                <div className="error_messages">
                  <Typography variant={{ colour: 'error' }}>
                    {errors.contactNumber}
                  </Typography>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            {useEffect(() => {
              /* eslint-disable no-param-reassign */
              values.channels = [];
              values.channelOrgCode = '';
              values.cpmsId = '';
              values.requiresOrderAccess = '';
              values.dealership = '';
              values.salesManager = '';
              values.salesManagerEmail = '';
              values.xid = '';
              values.outlet = '';
              channelArray = [];
              /* eslint-disable no-param-reassign */
            }, [values.role])}
            {useEffect(() => {
              /* eslint-disable no-param-reassign */
              values.channelOrgCode = '';
              values.cpmsId = '';
              values.requiresOrderAccess = '';
              values.dealership = '';
              values.salesManager = '';
              values.salesManagerEmail = '';
              values.xid = '';
              values.storeCode = '';
              /* eslint-disable no-param-reassign */
            }, [values.channels])}
            {values.role && (
              <>
                <div
                  className="main-content-form-headers"
                  style={{ marginTop: 20 }}
                >
                  <Typography>
                    {province}
                  </Typography>
                </div>
                <div
                  style={{ position: 'relative', width: '100%' }}
                  className={`frg-select-container color-light input-container ${errors.provinces && touched.provinces ? 'error' : ''
                    }`}
                >
                  {values.role === 'SALES_SUPPORT' ? (
                    <CheckboxGroup
                      legend={province}
                      items={provincesList && provincesList.length > 0 ? getUniqueItems(
                        provincesList,
                        (item) => item.value,
                        (item) => _.get(item, 'value', '')
                      ) : []}
                      checkedIds={provinceArray.map(p => p.value).filter(Boolean)}
                      onChange={(checkedIds) => {
                        // Map checked IDs back to province objects
                        const selectedProvinces = provincesList.filter(p => 
                          checkedIds.includes(p.value)
                        );
                        provinceArray = selectedProvinces;
                        values.provinces = selectedProvinces;
                        setFieldValue('provinces', selectedProvinces);
                        setProvinceArray([...selectedProvinces]);
                      }}
                      name="provinces"
                      validation={errors.provinces && touched.provinces ? 'error' : undefined}
                      feedback={errors.provinces && touched.provinces ? errors.provinces : undefined}
                    />
                  ) : (
                    <Field
                      as="select"
                      name="provinces"
                      placeholder="Select Group (Just one)"
                      className="select-style"
                    >
                      <option style={{ color: '#c3bfbf' }} disabled selected={!(touched && touched.role)} value="">
                        {Select_PROVINCE}
                      </option>
                      {provincesList &&
                        provincesList.length > 0 &&
                        provincesList.map(provinceOption => (
                          <option key={provinceOption.value} value={provinceOption.value}>{provinceOption.value}</option>
                        ))}
                    </Field>
                  )}
                  <>
                    <div className="error_messages">
                      <Typography variant={{ colour: 'error' }}>
                        {errors.provinces}
                      </Typography>
                    </div>
                    <div
                      id="username_error_icon"
                      className="error_messages_icon"
                    >
                      <img src={ErrorIcon} alt="error_icon" />
                    </div>
                  </>
                </div>

                {values.role &&
                  ![
                    ROLES.TELUS_MANAGER,
                    ROLES.ADT_RETENTION,
                    ROLES.TECH,
                    ROLES.CBM,
                    ROLES.EPP
                  ].includes(values.role) && (
                    <Box>
                      <div
                        className="main-content-form-headers"
                        style={{ marginTop: 20 }}
                      >{values.role === 'SALES_SUPPORT' ?
                        <Typography>
                          {supportchaneels}
                        </Typography>
                        :
                        <Typography>
                          {channelss}
                        </Typography>
                        }
                      </div>
                      <div
                        style={{ position: 'relative', width: '100%' }}
                        className={`frg-select-container color-light input-container ${errors.channels && touched.channels ? 'error' : ''
                          }`}
                      >
                        {values.role === 'SALES_SUPPORT' ? (
                          <CheckboxGroup
                            legend={supportchaneels}
                            items={getUniqueItems(
                              getChannels(values.role),
                              (item) => item.value,
                              (item) => _.get(item, 'label', '')
                            )}
                            checkedIds={channelArray.map(ch => ch.value).filter(Boolean)}
                            onChange={(checkedIds) => {
                              // Map checked IDs back to channel objects
                              const selectedChannels = getChannels(values.role).filter(ch => 
                                checkedIds.includes(ch.value)
                              );
                              channelArray = selectedChannels;
                              values.channels = selectedChannels;
                              setFieldValue('channels', selectedChannels);
                              setChannelArray([...selectedChannels]);
                            }}
                            name="channels"
                            validation={errors.channels && touched.channels ? 'error' : undefined}
                            feedback={errors.channels && touched.channels ? errors.channels : undefined}
                          />
                        ) : (
                          <Typeahead
                            clearButton
                            id="single-typehead"
                            highlightOnlyResult={true}
                            placeholder={Select_Channels}
                            labelKey="label"
                            onChange={e => {
                              setFieldValue('channels', e);
                              channelArray.push(e);
                              setChannelArray(channelArray);
                            }}
                            selected={values.channels || []}
                            options={getChannels(values.role)}
                          />
                        )}
                        <>
                          <div className="error_messages">
                            <Typography variant={{ colour: 'error' }}>
                              {errors.channels}
                            </Typography>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </Box>
                  )}

                {/* DEALER FORM */}
                {![
                  ROLES.TELUS_MANAGER,
                  ROLES.TECH,
                  ROLES.ADT_RETENTION,
                  ROLES.CBM,
                  ROLES.EPP,
                  ROLES.SALES_SUPPORT
                ].includes(values.role) &&
                  values.channels &&
                  channelsIncludes(values.channels, CHANNELS.DEALER) && (
                    <DealerForm
                      values={values}
                      labels={labels}
                      channelsList={channelsList}
                      touched={touched}
                      errors={errors}
                      setFieldValue={setFieldValue}
                    />
                  )}
                {/* CORP-STORE FORM */}
                {![
                  ROLES.TELUS_MANAGER,
                  ROLES.TECH,
                  ROLES.ADT_RETENTION,
                  ROLES.CBM,
                  ROLES.EPP
                ].includes(values.role) &&
                  values.channels &&
                  channelsIncludes(values.channels, CHANNELS.CORP_STORE) && (
                    <CorpStoreForm
                      values={values}
                      labels={labels}
                      channelsList={channelsList}
                      touched={touched}
                      errors={errors}
                      setFieldValue={setFieldValue}
                    />
                  )}

                {([ROLES.SALES_MANAGER].includes(values.role) &&
                  !channelsIncludes(values.channels, CHANNELS.DEALER)) && (
                    <>
                      <div className="main-content-form-headers">
                        <Typography>
                        {labels.CHANNEL_ORGANIZATION_CODE}
                        </Typography>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${errors.channelOrgCode && touched.channelOrgCode ? 'error' : ''
                      }`}
                      >
                        <Field
                          placeholder={labels.PLACEHOLDER_CHANNEL_ORGANIZATION_CODE}
                          className="select-style"
                          name="channelOrgCode"
                          type="text"
                        />
                        <>
                        <div className="error_messages">
                            <Typography variant={{ colour: 'error' }}>
                              {errors.channelOrgCode}
                            </Typography>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </>
                  )}
                {![ROLES.SALES_SUPPORT, ROLES.SALES_MANAGER].includes(values.role) &&
                  ((values.channels &&
                    !channelsIncludes(values.channels, CHANNELS.BCX_CARE) &&
                    !channelsIncludes(values.channels, CHANNELS.ADT) &&
                    !channelsIncludes(values.channels, CHANNELS.HEALTH) &&
                    !channelsIncludes(values.channels, CHANNELS.CSD) &&
                    !channelsIncludes(values.channels, CHANNELS.NBD)) ||
                    (!values.channels && values.role)) && (
                    <>
                      <div className="main-content-form-headers">
                        <Typography>
                          {labels.CPMS_ID}
                        </Typography>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${errors.cpmsId && touched.cpmsId ? 'error' : ''
                          }`}
                      >
                        <Field
                          placeholder={labels.CPMS_ID}
                          className="select-style"
                          name="cpmsId"
                          type="text"
                        // validate={validateCPMS}
                        />
                        <>
                          <div className="error_messages">
                            <Typography variant={{ colour: 'error' }}>
                              {errors.cpmsId}
                            </Typography>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </>
                  )}
                {/* OUTLET ID PART */}
                {![
                  ROLES.TELUS_MANAGER,
                  ROLES.TECH,
                  ROLES.ADT_RETENTION,
                  ROLES.CBM,
                  ROLES.EPP,
                  ROLES.SALES_SUPPORT
                ].includes(values.role) &&
                  ((values.channels &&
                    !channelsIncludes(values.channels, CHANNELS.BCX_CARE) &&
                    !channelsIncludes(values.channels, CHANNELS.ADT) &&
                    !channelsIncludes(values.channels, CHANNELS.HEALTH) &&
                    !channelsIncludes(values.channels, CHANNELS.CSD) &&
                    !channelsIncludes(values.channels, CHANNELS.NBD)) ||
                    (!values.channels && values.role)) && (
                    <>
                      <div className="main-content-form-headers">
                        <Typography>
                          {labels.OUTLET}
                        </Typography>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${errors.outlet && touched.outlet ? 'error' : ''
                          }`}
                      >
                        <Field
                          type="text"
                          placeholder={labels.OUTLET}
                          className="select-style"
                          name="outlet"
                          value={values.outlet}
                          onChange={({ target: { value } }) => {
                            setFieldValue('outlet', value);
                            const mappedChannel = getChannel(value);
                            if (mappedChannel)
                              setFieldValue('channels', mappedChannel);
                            const mappedStoreCode = getMappedStoreCode(value);
                            if(mappedStoreCode)
                                setFieldValue('storeCode',mappedStoreCode);
                          }}
                        />
                        <>
                          <div className="error_messages">
                            <Typography variant={{ colour: 'error' }}>
                              {errors.outlet}
                            </Typography>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </>
                  )}

                {/* XID PART */}
                {([ROLES.SALES_SUPPORT].includes(values.role) ||
                  channelsIncludes(values.channels, CHANNELS.BCX_CARE) ||
                  channelsIncludes(values.channels, CHANNELS.HEALTH) ||
                  channelsIncludes(values.channels, CHANNELS.CSD) ||
                  channelsIncludes(values.channels, CHANNELS.NBD) ||
                  channelsIncludes(values.channels, CHANNELS.ADT) ||
                  channelsIncludes(values.channels, CHANNELS.CORP_STORE)) && (
                    // , ROLES.SALES_SUPPORT [SOF-1750] Removed this because it's displaying twice in the sales support role
                    // This is commented because xid should be displayed if role = ADT Retention
                    // [CHANNELS.HOME_SOLUTION].includes(values.channels)
                    <>
                      <div className="main-content-form-headers">
                        <Typography>
                          {labels.XID_TID}
                        </Typography>
                      </div>
                      <Notification copy="en">
                        <Typography>
                          <b>{labels.NOTE}</b>: Enter your full TELUS ID starting with X or T (e.g., T123456)
                        </Typography>
                      </Notification>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${errors.xid && touched.xid ? 'error' : ''
                          }`}
                      >
                        <Field
                          placeholder={labels.XID_TID_PLACEHOLDER}
                          className="select-style"
                          type="text"
                          name="xid"
                        />
                        <>
                          <div className="error_messages">
                            <Typography variant={{ colour: 'error' }}>
                              {errors.xid}
                            </Typography>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </>
                  )}
                {[
                  ROLES.SALES_REP,
                  ROLES.SALES_MANAGER,
                  ROLES.SALES_SUPPORT
                ].includes(values.role) && (
                    <RestChannelsForm
                      values={values}
                      labels={labels}
                      touched={touched}
                      errors={errors}
                    />
                  )}
                {/* BCX Care Form */}
                {/* {![
                  ROLES.TELUS_MANAGER,
                  ROLES.TECH,
                  ROLES.ADT_RETENTION,
                  ROLES.CBM,
                  ROLES.EPP
                ].includes(values.role) &&
                  values.channels &&
                  channelsIncludes(values.channels, CHANNELS.BCX_CARE) && (
                    <BcxCareForm
                      values={values}
                      labels={labels}
                      touched={touched}
                      errors={errors}
                    />
                  )} */}

                {/* TelusSalesManagerForm */}
                {/* {(![
              ROLES.TELUS_MANAGER,
              ROLES.ADT_RETENTION,
              ROLES.CBM,
              ROLES.EPP,
              ROLES.SALES_REP,
              ROLES.SALES_MANAGER
            ].includes(values.role) &&
              values.channels &&
              !channelsIncludes(values.channels, CHANNELS.DEALER)) ||
              (channelsIncludes(values.channels, CHANNELS.HOME_SOLUTION) && (
                <TelusSalesManagerForm
                  values={values}
                  labels={labels}
                  touched={touched}
                  errors={errors}
                />
              ))}
            {[ROLES.CBM, ROLES.EPP].includes(values.role) && (
              <TelusSalesManagerForm
                values={values}
                labels={labels}
                touched={touched}
                errors={errors}
              />
            )} */}
              </>
            )}
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.recaptcha && touched.recaptcha ? 'error' : ''
                }`}
            >
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                name="recaptcha"
                onChange={onChange}
              />
            </div>

            <div
              id="continue_button"
              style={{ marginTop: 20, textAlign: 'center' }}
            >
              {!loading ? (
                <span>
                  <Button
                    type="submit"
                    onPress={submitForm}
                    variant={{ priority: 'high' }}
                    style={{ width: '100%' }}
                  >
                    {confirmationDialog.confirm}
                  </Button>
                </span>
              ) : (
                <span>
                  <Button
                    variant={{ priority: 'high' }}
                    type="button"
                    disabled
                    style={{ width: '100%' }}
                  >
                    <i className="fa fa-refresh fa-spin" />
                    {confirmationDialog.LOADING}
                  </Button>
                </span>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default salesManagerForm;
